import React, { useEffect, useState } from "react";
import { Button, Form, FormField, FormGroup, Grid, GridColumn, Header, Input, Segment, Select } from "semantic-ui-react";
import User from "../../../types/entities/User";
import { createUserPerson, updateUserPerson } from "../../../services/users.service";
import { toast } from "react-toastify";
import { GENDER_OPTIONS } from "../../../utils/dropdownOptions";

interface Props {
    userId: string | undefined;
    user: User | null;
    setUser: (user: User | null) => void;
}

interface RequestData {
    name?: string;
    paternalSurname?: string;
    maternalSurname?: string;
    gender?: string;
    phone?: string;
}

const UserPersonForm = ({ userId, user, setUser }: Props) => {

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [requestData, setRequestData] = useState<RequestData | undefined>(undefined);

    useEffect(() => {
        setRequestData({
            name: user?.person?.name || "",
            paternalSurname: user?.person?.paternalSurname || "",
            maternalSurname: user?.person?.maternalSurname || "",
            gender: user?.person?.gender || "",
            phone: user?.person?.phone || "",
        });
    }, [user]);

    const handleChange = (e: any, { name, value }: any) => {
        if (name === "phone" && !validatePhone(value)) return;
        setRequestData({
            ...requestData,
            [name]: value ?? "",
        } as RequestData);
    };

    const validatePhone = (phone: string) => {
        const regex = /^[0-9]+$/;
        if (phone.length > 10) {
            return false;
        }
        if (phone !== "" && !regex.test(phone)) {
            return false;
        }
        return true;
    }

    const handleSubmit = async (e: any) => {
        e.preventDefault();
        setIsSubmitting(true);

        try {

            if (!userId) {
                throw new Error("El id del usuario no puedo ser obtenido.");
            }

            if (requestData?.phone?.length !== 10) {
                throw new Error("El telefono no es valido, favor de verificar que sean 10 digitos sin espacios.");
            }

            if (user?.person?.id) {
                const response = await updateUserPerson(userId, user.person.id, requestData);

                if (response?.status === 200) {
                    setUser(response.data);
                    toast.success("El usuario ha sido actualizado exitosamente");
                } else {
                    throw new Error("Error al actualizar datos personales del usuario, favor de contactar al area de TI");
                }
            } else {
                const response = await createUserPerson(userId, requestData);

                if (response?.status === 201) {
                    setUser(response.data);
                    toast.success("El usuario ha sido creado exitosamente");
                } else {
                    throw new Error("Error al guardar datos personales del usuario, favor de contactar al area de TI");
                }
            }

        } catch (error: any) {
            toast.error(error.message);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Form onSubmit={handleSubmit}>
            <Grid>
                <GridColumn>
                    <Segment attached='top' color="grey" style={{ marginTop: 15 }}>
                        <Grid>
                            <GridColumn style={{ paddingTop: 5, paddingBottom: 5 }} verticalAlign="middle">
                                <Header as='h4' floated="left" style={{ marginTop: 8, marginBottom: 7 }}>Datos personales</Header>
                                {user?.person?.id ? (
                                    <Button floated="right" color="yellow" type="submit" style={{ margin: 0 }}>Actualizar</Button>
                                ) : (
                                    <Button floated="right" primary type="submit" style={{ margin: 0 }}>Guardar</Button>
                                )}
                            </GridColumn>
                        </Grid>
                    </Segment>
                    <Segment attached='bottom' loading={isSubmitting}>
                        <FormGroup widths='equal'>
                            <FormField
                                control={Input}
                                label='Nombre'
                                placeholder='Nombre(s)'
                                name="name"
                                value={requestData?.name}
                                onChange={handleChange}
                                required
                            />
                            <FormField
                                control={Input}
                                label='Apellido paterno'
                                placeholder='Apellido paterno'
                                name="paternalSurname"
                                value={requestData?.paternalSurname}
                                onChange={handleChange}
                                required
                            />
                            <FormField
                                control={Input}
                                label='Apellido materno'
                                placeholder='Apellido materno'
                                name="maternalSurname"
                                value={requestData?.maternalSurname}
                                onChange={handleChange}
                            />
                        </FormGroup>
                        <FormGroup widths='equal'>
                            <FormField
                                control={Select}
                                label='Genero'
                                options={GENDER_OPTIONS}
                                placeholder='Selecciona una opción...'
                                name="gender"
                                value={requestData?.gender}
                                onChange={handleChange}
                                clearable
                                required
                            />
                            <FormField
                                control={Input}
                                label='Telefono'
                                placeholder='10 caracteres numericos sin espacios ni guiones'
                                name="phone"
                                value={requestData?.phone}
                                onChange={handleChange}
                                required
                            />
                        </FormGroup>
                    </Segment>
                </GridColumn>
            </Grid>
        </Form>
    );
};

export default UserPersonForm;
